import NavBar from "../components/navbar";
import Footer from "../components/footer";
import event_photo from "../images/Mark.png"
import photo2 from "../images/Fab_FaceShot.png"
import photo3 from "../images/Gab.png"
import { Helmet } from 'react-helmet';

const products = [
    {
        id: 1,
        name: 'Mark Dugdale',
        imageSrc: event_photo,
        date: "CEO Front Row",
        

    },
    {
        id: 2,
        name: 'Fabio Rossi',
        imageSrc: photo2,
        date: "CTO Front Row",
        

    },
    {
        id: 3,
        name: 'Gabriel Chouman',
        imageSrc: photo3,
        date: "C00 Front Row",
        

    },


    // More products...
]

export default function About({principal,setPrincipal}) {
    return (
        <>
            <Helmet>
                <title>About</title>
            </Helmet>
            <div className="bg-background">
                <NavBar principal={principal} setPrincipal={setPrincipal}></NavBar>


                <div className="mx-auto px-2 sm:px-4 lg:px-8">
                    <div className="pt-10">
                        <h2 className="text-6xl not-italic font-bold text-white font-title leading-10">About Us</h2>
                        <p className="mt-6 text-lg leading-8 text-white">
                        Meet the Team
                        </p>
                    </div>
                </div>

                {/* Content section */}
                <div className="mx-auto mt-20 px-6 lg:px-8">
                    <div className="mx-auto max-w-2xl lg:mx-0 lg:max-w-none">
                        <div className="grid max-w-xl grid-cols-1 gap-8 text-base leading-7 text-white lg:max-w-none lg:grid-cols-5">
                            <div className="col-span-2">
                                <p>
                                    Welcome to Front Row, your ticket to the heart of the dynamic world of web3 and the Internet Computer protocol. At Front Row, we are not just selling tickets; we are crafting experiences. We are ardent believers in the potential of web3 and the revolutionary Internet Computer protocol, and our passion drives us to connect enthusiasts, developers, and visionaries. What sets us apart is not just the events we host but the way we host them. Our platform is proudly hosted 100% on chain, utilizing the power of the protocol itself.
                                </p>
                                <p className="mt-8">
                                    Front Row is more than a ticketing platform; it's a community hub designed to keep you at the forefront of the latest crypto events. We curate and offer tickets to the most important gatherings within the web3 community, ensuring you don’t just attend events but actively participate in the future of the decentralized web. What makes our tickets even more special is that they are sold as NFTs, making each event entry a unique digital asset, yours to own and cherish.
                                </p>
                                <p className="mt-8">
                                    Our mission is simple: we want to be your gateway to the most influential discussions, innovations, and connections within the world of blockchain technology. Join us, and let’s shape the future of the Internet, one event at a time. Welcome to the Front Row experience, where every connection is a step into the decentralized future.
                                </p>
                            </div>
                            <div className="mx-5 col-span-3">
                                <h2 className="text-2xl not-italic font-medium leading-9 font-title">The Team</h2>
                                <div className="mt-6 grid grid-cols-1 gap-x-6 gap-y-10 sm:grid-cols-2 lg:grid-cols-3 xl:gap-x-8">
                                    {products.map((product) => (
                                        <div key={product.id} className="group relative">
                                            <div className="aspect-w-1 w-full h-64 overflow-hidden bg-gray-200 lg:aspect-none group-hover:scale-105 transition duration-500 cursor-pointer lg:h-64">
                                                <img
                                                    src={product.imageSrc}
                                                    className="h-full w-full object-cover object-center lg:h-full lg:w-full"
                                                />
                                            </div>
                                            <div className="mt-4 flex justify-between">
                                                <div>
                                                    <h3 className="text-lg not-italic font-bold font-title leading-6 text-white">
                                                        <a href={product.href}>
                                                            <span aria-hidden="true" className="absolute inset-0" />
                                                            {product.name}
                                                        </a>
                                                    </h3>
                                                    <p className="mt-2 text-sm not-italic font-medium leading-5 font-text text-white">{product.date}</p>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <Footer></Footer>
            </div>
        </>

    )
}